import React from 'react';
import { List } from 'immutable';
import { Paragraph } from '@uncinc/react-drupal-core';
import { Fade } from 'react-awesome-reveal';
import c from 'classnames';

import {
  Container,
} from '../../../components';

const ParagraphCards = ({ entity }) => {
  const anchor = entity.getIn(['field_anchor', 0, 'value']);
  const amount = entity.get('field_paragraphs').size;
  const classes = c({
    'col-12': true,
    'col-sm-6 col-lg-3': amount === 4,
    'col-sm-4': amount === 3,
  });
  const paragraphId = entity.getIn(['id', 0, 'value']);
  const paragraphKey = `paragraph:${paragraphId}`;

  return (
    <Container id={paragraphKey} className="Paragraph Cards">
      <Fade triggerOnce bottom distance="50px" duration={500}>
        <div className="Cards__wrapper row">
          {anchor && <a id={anchor} />}
          {
            entity.getIn(['field_paragraphs'], List()).map((item) => {
              const paragraphId = item.get('target_id');
              const paragraph = item.get('entity');
              const paragraphKey = `paragraph:${paragraphId}`;
              return (
                <div key={paragraphKey} id={paragraphKey} className={classes}>
                  <Paragraph entity={paragraph} id={paragraphId} key={paragraphId} />
                </div>
              );
            })
          }
        </div>
      </Fade>
    </Container>
  );
};

export default ParagraphCards;
